import * as _feature from '@angular/core'

import * as _actions from '../actions'
import type * as _effects from '../effects'
import type { Feature } from '../feature'
import type * as models from '../models'
import type * as _reducers from '../reducers'
import * as _selectors from '../selectors'

import * as lifecycleEffects from './effects'

/**
 * TODO:
 */
export class Lifecycle<TFeature extends Feature.Constraint<TState>, TState> {
  /** TODO */
  // NOTE: intentionally missing return type so that type can be inferred
  public readonly actions

  public get isDestroyed(): boolean {
    return this._isDestroyed
  }

  private _isDestroyed = false

  constructor(public readonly feature: TFeature) {
    const actionConfig = {
      /**
       * Attempts to erase all signs the {@link Feature} ever existed
       *
       * Once destroyed, the {@link Feature} can no longer be used
       */
      destroy: _actions.standalone({
        data: ({ recursive = false }: models.Recursive.Optionally = {}) => ({
          recursive,
        }),
        // TODO: change to use `reducer` instead of `reducerDeprecated`, however
        // _actions.Group.create<TState, unknown, typeof actionConfig> causes
        // typing problem
        reducerDeprecated: (state: TState, { recursive }) => {
          this._isDestroyed = true
          // NOTE: these have side effects, which is supposed to happen in an
          // effect, not a reducer. However, it is important the destruction
          // happens immediately, so that we don't have a race condition where
          // some reducer or effect tries to use this feature after it has been
          // destroyed, but before the effect to disable reducers/effects has
          // been triggered
          feature.unregisterAllExtraReducers({ recursive })
          feature.unregisterAllEffects({ recursive })
          // NOTE: this is how we communicate to the meta reducer that we want
          // to delete the state
          return undefined as any as Readonly<typeof state>
        },
      }),
    } as const

    this.actions = _actions.Group.create<TState, unknown, typeof actionConfig>(
      feature,
      actionConfig,
    )

    feature.registerEffects(lifecycleEffects.recursivelyDestroyFeatures())
  }
}
